<template>
    <div class="popup">
        <van-popup :value="show" @click-overlay="close">
            <div class="content">
                <statusBar></statusBar>
                <div class="header">
                    <div>{{ $t("withdraw.Add") + ' PIX' }}</div>
                    <div class="close">
                        <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                    </div>
                </div>
                <div class="info_box">
                    <a-form-model ref="ruleForm" :model="formData" :rules="rules" @submit.native.prevent>
                        <div class="form__item bankSelect bankInput" @click.stop="isShowBankList = !isShowBankList">
                            <div class="form__item__prefix">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    fill="none" version="1.1" width="56" height="56" viewBox="0 0 56 56">
                                    <defs>
                                        <clipPath id="master_svg0_174_10560">
                                            <rect x="0" y="0" width="56" height="56" rx="0" />
                                        </clipPath>
                                    </defs>
                                    <g clip-path="url(#master_svg0_174_10560)">
                                        <g>
                                            <path
                                                d="M27.9965046875,51.493837890625C14.0177046875,51.493837890625,6.9248046875,48.351837890625,6.9248046875,42.152637890625C6.9248046875,37.731337890625,14.2340646875,34.824537890624995,21.5057046875,33.846237890625005L21.5057046875,32.924337890625C17.1314046875,29.867037890625,15.0054346875,24.533337890625,15.0054346875,16.669037890625C15.0054346875,9.049337890625,19.7748046875,4.496337890625,27.7708046875,4.496337890625L28.2035046875,4.496337890625C36.1994046875,4.496337890625,40.9688046875,9.049337890625,40.9688046875,16.669037890625C40.9688046875,19.632237890625,40.9688046875,28.408937890625,34.5250046875,32.933737890625L34.5062046875,33.846237890625005C41.7778046875,34.833937890624995,49.0589046875,37.731337890625,49.0589046875,42.143237890625C49.0683046875,48.351837890625,41.9754046875,51.493837890625,27.9965046875,51.493837890625ZM27.7802046875,7.741757890625C23.4341046875,7.741757890625,18.2509046875,9.293917890625,18.2509046875,16.669037890625C18.2509046875,23.761937890625,20.1229046875,28.343137890625,23.9703046875,30.657237890625C24.4595046875,30.948837890625,24.7511046875,31.475637890625,24.7511046875,32.040137890625005L24.7511046875,35.285537890625C24.7511046875,36.122737890625004,24.1208046875,36.818837890625,23.2930046875,36.894137890625C15.4005346875,37.684337890625,10.1702246875,40.581637890625,10.1702246875,42.143237890625C10.1702246875,47.185437890625,19.8689046875,48.248437890625,27.9965046875,48.248437890625C36.1336046875,48.248437890625,45.8228046875,47.194837890625,45.8228046875,42.143237890625C45.8228046875,40.572237890625,40.5925046875,37.684337890625,32.7000046875,36.894137890625C31.8534046875,36.809437890625,31.2231046875,36.094537890625,31.2420046875,35.247937890624996L31.3172046875,32.002437890625C31.3266046875,31.447437890625,31.6276046875,30.939437890625,32.0980046875,30.647837890625C35.954904687500004,28.324337890625,37.7422046875,23.884237890625,37.7422046875,16.659637890625C37.7422046875,9.275107890625,32.558904687500004,7.732357890625,28.2129046875,7.732357890625L27.7802046875,7.741757890625Z"
                                                fill="#fffafe" fill-opacity="0.4000000059604645" />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div class="bankInput_txt">{{ formData.bankType }}</div>
                            <div v-if="isShowBankList" class="bankSelect_list">
                                <div v-for="(item, index) in columns" :key="index"
                                    :class="{ 'act': formData.bankType == item.value }"
                                    @click.stop="changeBankType(item.value)">{{ item.label }}</div>
                            </div>
                        </div>
                        <a-form-model-item ref="pixAccount" label="" prop="pixAccount">
                            <a-input v-model="formData.pixAccount" :placeholder="$t('bankset.PIXAccountCNPJ')">
                                <svg slot="prefix" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="56"
                                    height="56" viewBox="0 0 56 56">
                                    <defs>
                                        <clipPath id="master_svg0_174_10521">
                                            <rect x="0" y="0" width="56" height="56" rx="0" />
                                        </clipPath>
                                    </defs>
                                    <g clip-path="url(#master_svg0_174_10521)">
                                        <g>
                                            <path
                                                d="M45.2795,49L10.39752,49C5.87578,49,2,45.4462,2,40.6L2,15.4C2,10.87692,5.5527999999999995,7,10.39752,7L45.6025,7C50.1242,7,54,10.55385,54,15.4L54,40.9231C53.677,45.4462,50.1242,49,45.2795,49ZM10.39752,10.23077C7.49068,10.23077,5.2298100000000005,12.49231,5.2298100000000005,15.4L5.2298100000000005,40.9231C5.2298100000000005,43.8308,7.49068,46.0923,10.39752,46.0923L45.6025,46.0923C48.5093,46.0923,50.7702,43.8308,50.7702,40.9231L50.7702,15.4C50.7702,12.49231,48.5093,10.23077,45.6025,10.23077L10.39752,10.23077ZM13,24C13,25.9053,13.8489,27.6521,15.2078,28.9242C11.57713,30.4364,9.00571,33.7061,8.08378,38C7.76172,39,8.405840000000001,39.6667,9.37202,40C10.3382,40,10.98232,39.6667,11.30438,38.6667C12.2706,32.3333,17.1015,31.3333,20,31.3333C22.8985,31.3333,27.7294,32.3333,29.0177,38.6667C29.3397,39.3333,29.9839,40,30.628,40C31.5942,39.6667,32.238299999999995,39,31.9162,38C31.2737,33.7879,28.9217,30.7554,25.6182,29.1964C27.0783,27.9575,28,26.1508,28,24C28,20.181800000000003,24.5909,17,20.5,17C16.409100000000002,17,13,20.181800000000003,13,24ZM20.5,20.181800000000003C18.1136,20.181800000000003,16.068199999999997,22.090899999999998,16.068199999999997,24C16.068199999999997,25.9091,18.1136,27.8182,20.5,27.8182C22.8864,27.8182,24.5909,26.2273,24.5909,24C24.5909,21.7727,22.5455,20.181800000000003,20.5,20.181800000000003ZM45.375,25L35.625,25C34.65,25,34,24.4,34,23.5C34,22.6,34.65,22,35.625,22L45.375,22C46.35,22,47,22.6,47,23.5C47,24.4,46.35,25,45.375,25ZM39.25,33L35.75,33C34.7,33,34,32.2,34,31C34,29.8,34.7,29,35.75,29L39.25,29C40.3,29,41,29.8,41,31C41,32.2,40.3,33,39.25,33Z"
                                                fill-rule="evenodd" fill="#fffafe" fill-opacity="0.4000000059604645" />
                                        </g>
                                    </g>
                                </svg>
                            </a-input>
                        </a-form-model-item>
                        <a-form-model-item label="" prop="cpfAccount">
                            <a-input v-model="formData.cpfAccount" :placeholder="$t('bankset.CPFAccount')">
                                <svg slot="prefix" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="56"
                                    height="56" viewBox="0 0 56 56">
                                    <defs>
                                        <clipPath id="master_svg0_174_10545">
                                            <rect x="0" y="0" width="56" height="56" rx="0" />
                                        </clipPath>
                                    </defs>
                                    <g clip-path="url(#master_svg0_174_10545)">
                                        <g>
                                            <path
                                                d="M2,28C2,13.7,13.7,2,28,2C42.3,2,54,13.7,54,28C54,42.3,42.3,54,28,54C13.7,54,2,42.3,2,28ZM5.25,28C5.25,40.675,15.325,50.75,28,50.75C40.675,50.75,50.75,40.675,50.75,28C50.75,15.325,40.675,5.25,28,5.25C15.325,5.25,5.25,15.325,5.25,28ZM40.6667,28.9846C44,30.6,46,33.830799999999996,46,37.3846C46,38.0308,45.3333,39,44.3333,39C43.3333,39,42.6667,38.3538,42.6667,37.3846C42.6667,33.830799999999996,39.6667,30.9231,36,30.9231C32.3333,30.9231,29.3333,33.830799999999996,29.3333,37.3846C29.3333,38.3538,28.6667,39,27.6667,39C26.6667,39,26,38.3538,26,37.3846C26,33.5077,28,30.2769,31.3333,28.9846C30,27.6923,29.3333,26.0769,29.3333,24.4615C29.3333,20.9077,32.3333,18,36,18C39.6667,18,42.6667,20.9077,42.6667,24.4615C42.6667,26.4,41.6667,27.6923,40.6667,28.9846ZM11.625,24L21.375,24C22.35,24,23,23.4,23,22.5C23,21.6,22.35,21,21.375,21L11.625,21C10.65,21,10,21.6,10,22.5C10,23.1,10.65,24,11.625,24ZM32.6667,24.4615C32.6667,26.4,34,27.6923,36,27.6923C38,27.6923,39.3333,26.0769,39.3333,24.4615C39.3333,22.5231,38,21.2308,36,21.2308C34,21.2308,32.6667,22.5231,32.6667,24.4615ZM11.625,31L21.375,31C22.35,31,23,30.2,23,29C23,27.8,22.35,27,21.375,27L11.625,27C10.65,27,10,27.8,10,29C10,29.8,10.65,31,11.625,31ZM11.625,34L21.375,34C22.35,34,23,34.6,23,35.5C23,36.4,22.35,37,21.375,37L11.625,37C10.65,37,10,36.4,10,35.5C10,34.6,10.65,34,11.625,34Z"
                                                fill-rule="evenodd" fill="#fffafe" fill-opacity="0.4000000059604645" />
                                        </g>
                                    </g>
                                </svg>
                            </a-input>
                        </a-form-model-item>
                    </a-form-model>
                </div>
                <div class="tips">{{ $t('bankset.banksetPopupTips3') }}</div>
                <div class="action_btn" @click="formSubmit">
                    <span>{{ $t("lang.confirm") }}</span>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import statusBar from '@/components/statusBar'
import { saveBankBrazil, updateBankBrazil } from '@/api/withdraw'
import { Toast } from 'vant'
import md5 from 'md5'
import { deepClone } from '@/utils'
export default {
    name: 'changePwd',
    components: { statusBar },
    data() {
        return {
            show: false,
            isFocus: 0,
            columns: [{
                value: 'CNPJ',
                label: 'CNPJ'
            }],
            formData: {
                bankType: 'CNPJ',
                accountName: '',
                pixAccount: '',
                cpfAccount: '',
                withdrawPassword: '',
                withdrawPasswordVerify: ''
            },
            rules: {},
            isShowBankList: false,
            canCallHandleWithDraw: true
        }
    },
    methods: {
        open() {
            const that = this
            const withdrawPwdForm = that.$store.getters.withdrawPwdForm
            if (withdrawPwdForm) {
                const pwdForm = JSON.parse(decodeURIComponent(withdrawPwdForm))
                that.formData.withdrawPassword = pwdForm.pwd1
                that.formData.withdrawPasswordVerify = pwdForm.pwd2
            }
            this.show = true
        },
        close() {
            this.formData = {
                bankType: 'CNPJ',
                accountName: '',
                pixAccount: '',
                cpfAccount: '',
                withdrawPassword: '',
                withdrawPasswordVerify: ''
            }
            this.show = false
        },
        changeBankType(e) {
            this.formData.bankType = e
            this.isShowBankList = false
            this.$forceUpdate()
        },
        formSubmit() {
            const that = this
            const formdata = that.formData
            that.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    if (that.canCallHandleWithDraw) {
                        if (!formdata.pixAccount) {
                            Toast(this.$t('bankset.InputPIXAccount'))
                            return
                        }
                        if (!formdata.cpfAccount) {
                            Toast(this.$t('bankset.PleaseEnterCPF'))
                            return
                        }
                        that.canCallHandleWithDraw = false
                        const form = deepClone(formdata)
                        form.accountName = form.pixAccount
                        if (form.withdrawPassword) form.withdrawPassword = md5(form.withdrawPassword)
                        if (form.withdrawPasswordVerify) form.withdrawPasswordVerify = md5(form.withdrawPasswordVerify)
                        let result
                        if (form.id) {
                            result = await updateBankBrazil(form)
                        } else {
                            result = await saveBankBrazil(form)
                        }
                        that.canCallHandleWithDraw = true
                        Toast(result.message)
                        if (result.code) return
                        that.$emit('setBankSucc')
                        that.close()
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    &.mobile {

        .van-popup {
            &.van-popup--center {
                width: 100% !important;
                height: 100% !important;
                max-width: 100% !important;
                min-height: 100% !important;
                max-height: 100% !important;
            }

            .content {
                width: 100% !important;
                // padding-bottom: .4rem;
                height: 100% !important;

                .header {
                    height: .94rem;
                    padding: 0 .28rem;

                    &>div:first-child {
                        font-size: .3rem;
                    }

                    .close {
                        font-size: .3rem;
                    }
                }
            }
        }
    }

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;

        .content {
            background: $bg-popup-color;
            width: 94%;
            // height: 700px;
            border-radius: .24rem;
            overflow: auto;
            display: flex;
            flex-direction: column;

            .header {
                display: flex;
                height: .88rem;
                padding: 0 .5rem;
                padding-top: .18rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                // background: $bg-popup-navbar-color;

                &>div:first-child {
                    font-size: .26rem;
                    font-weight: bold;
                    color: $font-color;
                }

                .close {
                    color: $font-iconfont-color;
                    font-size: .42rem;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        color: $font-color;
                        rotate: -180deg;
                    }
                }
            }

            .info_box {
                padding: .16rem 0;
                text-align: left;
                width: 80%;
                margin: 0 auto;

                ::v-deep .ant-form {
                    .ant-form-item {
                        margin-bottom: .36rem;

                        &.ant-form-item-with-help {
                            margin-bottom: .05rem;
                        }

                        .tabler-icon {
                            width: .3rem;
                            height: .3rem;
                        }
                        .ant-col{
                            .ant-form-item-control{
                                line-height: .68rem !important;
                            }
                        }
                    }

                    .has-error {
                        .ant-input-prefix {
                            .iconfont {
                                position: relative;

                                &:after {
                                    content: '*';
                                    position: absolute;
                                    color: $font-component-hot-color;
                                    top: .02rem;
                                    right: -.1.5rem;
                                    font-size: .24rem;
                                }
                            }
                        }
                    }
                }

                .ant-input-affix-wrapper {
                    background-color: transparent;

                    &.phone {
                        ::v-deep .ant-input {
                            padding-left: 1.2rem !important;
                        }

                        ::v-deep .ant-input-prefix {
                            .form__item__prefix {
                                position: relative;
                                height: 0.66rem;
                                width: 1.2rem;
                                display: flex;
                                align-items: center;
                                justify-content: flex-start;
                                font-size: .28rem;

                                img {
                                    width: .36rem;
                                    height: .36rem;
                                    margin-right: .08rem;
                                }
                            }
                        }
                    }

                    ::v-deep .ant-input-prefix {
                        left: .14rem;
                        color: $font-iconfont-color;

                        svg {
                            width: .38rem;
                            height: .38rem;
                        }
                    }

                    ::v-deep .ant-input {
                        background-color: $bg-input-color !important;
                        border-radius: 0.08rem;
                        font-size: 0.22rem;
                        height: 0.66rem;
                        padding: 0px 0.6rem !important;
                        color: $font-component-light-color;
                        border: .02rem solid $border-input-color !important;

                        &:focus {
                            background: $bg-input-act-color !important;
                            border-color: $border-active-color !important;
                        }

                        &::-webkit-input-placeholder {
                            /* WebKit browsers */
                            font-size: .22rem;
                            color: $font-placeholder-color;
                        }

                        &:-moz-placeholder {
                            /* Mozilla Firefox 4 to 18 */
                            font-size: .22rem;
                            color: $font-placeholder-color;
                        }

                        &::-moz-placeholder {
                            /* Mozilla Firefox 19+ */
                            font-size: .22rem;
                            color: $font-placeholder-color;
                        }

                        &:-ms-input-placeholder {
                            /* Internet Explorer 10+ */
                            font-size: .22rem;
                            color: $font-placeholder-color;
                        }
                    }

                    ::v-deep .ant-input-suffix {
                        .ant-input-clear-icon {
                            color: $font-iconfont-color;
                            font-size: .32rem;
                        }
                    }

                    &.ant-input-password {
                        ::v-deep .ant-input {
                            padding-right: 1rem;
                        }

                        ::v-deep .ant-input-suffix {
                            .ant-input-password-icon {
                                margin-right: .1rem;
                                font-size: .3rem;
                                color: $font-iconfont-color;
                            }
                        }
                    }
                }

                .form__item {
                    height: 0.66rem;
                    box-sizing: border-box;
                    position: relative;
                    border: .01rem solid $border-input-color;
                    background-color: $bg-input-color;
                    width: 100%;
                    border-radius: .08rem;
                    padding-left: .65rem;

                    &.act {
                        border: .01rem solid $border-active-color;
                        background-color: $bg-input-act-color;
                    }

                    &__prefix {
                        position: absolute;
                        height: .66rem;
                        width: .65rem;
                        left: 0;
                        top: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &>svg {
                            width: .4rem;
                            height: .4rem;
                            color: $font-iconfont-color;
                        }
                    }
                }

                .bankSelect {
                    width: 100%;
                    background-color: $bg-input-color;
                    border: .01rem solid $border-input-color;
                    position: relative;
                    display: flex;
                    align-items: center;
                    border-radius: .12rem;
                    margin-bottom: .2rem;

                    &:after {
                        content: '';
                        width: .16rem;
                        height: .16rem;
                        border-top: .01rem solid $font-iconfont-color;
                        border-right: .01rem solid $font-iconfont-color;
                        transform: rotate(135deg);
                        position: absolute;
                        right: .24rem;
                        top: .24rem;
                    }

                    &.bankInput {
                        color: $font-color;
                        display: flex;
                        align-items: center;
                        font-size: .24rem;
                        position: relative;

                        .bankInput_txt {
                            padding: .12rem 0;
                        }

                        &>img {
                            width: .9rem;
                            height: .78rem;
                        }

                        .bankSelect_list {
                            position: absolute;
                            width: 100%;
                            top: .7rem;
                            left: 0;
                            background-color: $bg-input-color;
                            border: .01rem solid $border-input-color;
                            border-radius: .08rem;
                            z-index: 9;
                            padding: .1rem 0;
                            z-index: 2;
                            color: $font-placeholder-color;
                            z-index: 3;

                            &>div {
                                background: transparent;
                                border: 0;
                                border-radius: 0;
                                line-height: .7rem;
                                padding-left: .28rem;
                                cursor: pointer;

                                &.act {
                                    color: $font-color;
                                }
                            }
                        }
                    }
                }
            }

            .tips {
                color: $font-color;
                font-size: .24rem;
                line-height: .3rem;
                letter-spacing: .02rem;
                width: 80%;
                margin: 0 auto;

                &>div {
                    margin-bottom: .08rem;
                }
            }

            .action_btn {
                height: .7rem;
                background: $bg-btn-color;
                border-radius: .64rem;
                margin: .5rem .28rem;
                margin-bottom: .2rem;
                font-family: eryawenrunti;
                font-size: .3rem;
                color: $font-btn-color;
                text-align: center;
                line-height: .7rem;
                cursor: pointer;

                &.disabled {
                    background: $bg-component-disabled-solid-color;
                    color: rgba(255, 255, 255, 0.45);
                    cursor: not-allowed;
                    box-shadow: 0 .06rem 0 0 $shadow-component-base-color, 0 .02rem .03rem 0 $border-component-deep-color, 0 .02rem .03rem 0 $font-component-pale-color;
                }
            }
        }
    }
}
</style>
